import axios from "axios";
import store from "@/store";
export const BASE_URL = "/api";

const instance = axios.create({ baseURL: BASE_URL });
let renewRequest = null;
let isRedirected = false;

instance.interceptors.request.use((config) => {
  const token = store.state.user.access_token;
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

instance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config;
    const isAuthError = status === 401;
    /**
     * Если 401, то надо обновить токен
     */
    if (isAuthError && !originalRequest.ignoreAuthError) {
      originalRequest.ignoreAuthError = true;
      // если запроса за обновлением токена
      // еше нет, то создадим
      if (!renewRequest) {
        renewRequest = store.dispatch("user/renewToken", {
          noAuthRedirect: originalRequest.noAuthRedirect,
          ignoreAuthError: true,
        });
      }
      try {
        const res = await renewRequest;
        // Сетим новый токен в заголовки
        originalRequest.headers[
          "Authorization"
        ] = `Bearer ${res?.access_token}`;
        renewRequest = null;
        return instance(originalRequest);
      } catch (err) {
        renewRequest = null;
      }
    }
    if (isAuthError && !error.config.noAuthRedirect && !isRedirected) {
      isRedirected = true;
      window.location.pathname = process.env.VUE_APP_ROOT_PREFIX + "/";
    }
    return Promise.reject(error);
  }
);

export const request = instance;
